export default "__VITE_ASSET__odIh0ZAV__"